import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { PricebookValidity } from "../../../types/price-book.type";
import { todayInBangkok } from "../../../utils/date";
import {
  VALIDITY_STATE_COLOR,
  ValidityState,
  buildFacePriceFallbackNote,
  formatValidityText,
  resolveValidityState,
} from "./validityModel";

const STATE_LABEL: Partial<Record<ValidityState, string>> = {
  upcoming: "ยังไม่เริ่มใช้",
  ended: "หมดช่วงใช้แล้ว",
};

interface ValidityNoteProps {
  validity: PricebookValidity;
  /** The face-price book's code from the system settings; undefined while they load. */
  facePriceCode: string | undefined;
}

/**
 * The days a book prices on ("ใช้ได้ 01/11/2026 – 30/11/2026" / "เริ่มใช้ 01/11/2026"), whether
 * it prices today, and what its shops bill at outside them. Nothing for a book valid every day.
 */
export default function ValidityNote({ validity, facePriceCode }: ValidityNoteProps) {
  const text = formatValidityText(validity);
  if (!text) return null;

  const state = resolveValidityState(validity, todayInBangkok());
  const stateLabel = STATE_LABEL[state];

  return (
    <Stack direction="row" alignItems="center" flexWrap="wrap" gap={1} sx={{ mt: 1 }}>
      <Chip size="small" variant="outlined" color={VALIDITY_STATE_COLOR[state]} label={text} />
      {stateLabel && (
        <Chip size="small" color={VALIDITY_STATE_COLOR[state]} label={stateLabel} />
      )}
      <Typography variant="caption" color="text.secondary">
        {buildFacePriceFallbackNote(validity, facePriceCode)}
      </Typography>
    </Stack>
  );
}
